import ApplicationHeader from "./application_header";
import type Application from "@/types/application";
import { Stack, Row } from "@sprout/layout";
import { Tag } from "@sprout/tag";
import Divider from "@sprout/divider";
import { SecondaryBody } from "@sprout/typography";

import "./selected_application.scss";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Tooltip from "@/sprout/tooltip";
import ErrorIcon from "@/sprout/icons/error";
import { SecondaryButton } from "@sprout/buttons";
import Stages from "@components/applications/stages.tsx";

type Props = {
  application: Application;
  hasTokens: boolean;
  onViewParentApplication: (id: number) => void;
};

const SelectedApplication = ({ application, hasTokens, onViewParentApplication }: Props) => {
  const { t } = useTranslation("applications", { keyPrefix: "dream_job_callout" });

  const [currentApplication, setCurrentApplication] = useState(application);

  useEffect(() => {
    setCurrentApplication(application);
  }, [application]);

  const onAddDreamJob = async () => {
    setCurrentApplication({ ...currentApplication, dream_job: true });
  };

  const handleViewFirstApplication = () => {
    if (currentApplication.duplicate_of_application_id) {
      onViewParentApplication(currentApplication.duplicate_of_application_id);
    }
  };

  return (
    <Stack gap="16px">
      <ApplicationHeader
        application={currentApplication}
        hasTokens={hasTokens}
        onAddDreamJob={onAddDreamJob}
      />
      <Stack gap="24px">
        <Row gap="8px" align="center">
          {currentApplication.locations && (
            <Tooltip text={currentApplication.locations}>
              <Tag label={currentApplication.locations} maxWidth="max-w-52" />
            </Tooltip>
          )}
          {/* Salary is out of scope */}
          <SecondaryBody>{currentApplication.status_message}</SecondaryBody>
        </Row>
        {currentApplication.inactive && currentApplication.duplicate && (
          <Row gap="8px" align="center" className="duplicate-callout">
            <div className="w-full bg-marigold-25 px-6 py-4 border-marigold-e50 rounded-sm">
              <div className="flex flex-col gap-4 xl:flex-row items-start">
                <Stack gap="0">
                  <Row gap="4px" align="center">
                    <ErrorIcon size="md" color="light-yellow" />
                    <p className="text-sm w-full">{t("duplicate_application.description")}</p>
                  </Row>
                </Stack>

                {currentApplication.duplicate_of_application_id && (
                  <SecondaryButton size="medium" onClick={handleViewFirstApplication}>
                    {t("duplicate_application.button")}
                  </SecondaryButton>
                )}
              </div>
            </div>
          </Row>
        )}
        <Stack gap="24px">
          <Divider />
          <div className="application--content">
            <div
              className="job-post-contents"
              dangerouslySetInnerHTML={{ __html: currentApplication.description }}
            />
            <Stages application={currentApplication} />
          </div>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SelectedApplication;
